import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { useCompanyAttributeValues } from "@/lib/use-company-attribute-values"
import { useThreadsFilterState } from "../threads-filter-state"

export function CompanyTierFilterItems({ onSelect }: SharedFilterItemsProps) {
	const { companyTiers, addCompanyTier, removeCompanyTier } =
		useThreadsFilterState()

	const { tiers: availableTiers } = useCompanyAttributeValues()

	return (
		<>
			{availableTiers.map((tier) => (
				<CommandItem
					key={tier}
					onSelect={() => {
						if (companyTiers.includes(tier)) {
							removeCompanyTier(tier)
						} else {
							addCompanyTier(tier)
						}
						onSelect()
					}}
				>
					<span className="flex w-full items-center justify-between">
						<span className="truncate">{tier}</span>
						<Check
							className={cn("h-4 w-4 shrink-0", {
								"opacity-100": companyTiers.includes(tier),
								"opacity-0": !companyTiers.includes(tier),
							})}
						/>
					</span>
				</CommandItem>
			))}
		</>
	)
}
